import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type { ISessionResponse } from '../types';
import {
  TOKEN_API_URL,
  TOKENS_QUERY_KEY,
} from '../constants';

export default function useTokensQuery(): IContextQueryResult<ISessionResponse, Error> {
  const { fetchGet } = useRestClient();

  return useContextQuery({
    queryKey: [TOKENS_QUERY_KEY],
    refetchOnMount: false,
    gcTime: Infinity,
    staleTime: Infinity,
    queryFn: ({ signal }) => fetchGet<ISessionResponse>(TOKEN_API_URL, {
      signal,
      isEssential: true,
    }),
  });
}
